import { useState, useEffect } from 'react';

export function useClientHasRendered() {
  const [hasRendered, setHasRendered] = useState(false);

  useEffect(() => {
    setHasRendered(true);
  }, []);

  return hasRendered;
}
